import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import { Row, Col, Button } from 'antd';
import ProductImage from './Sections/ProductImage';
import { addToCart } from '../../../_actions/user_actions';
import { useDispatch } from 'react-redux';
import YoutubeEmbed, { getYoutubeMovieIDfromURL } from '../../utils/YoutubeEmbed';
import ProductCard from '../../utils/ProductCard';
import { deleteStoredImage } from '../../utils/S3Helper';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export const BtnMargined = styled(Button)`
    & + & {
        margin-left: 10px;
    }
`;

function DetailProductPage(props) {
    const dispatch = useDispatch();
    const productId = props.match.params.productId;
    const [Product, setProduct] = useState([]);
    const [Title, setTitle] = useState("");
    const [ImgURL, setImgURL] = useState();
    const [MovieID, setMovieID] = useState();
    const history = useHistory();

    useEffect(() => {
        Axios.get(`/api/product/products_by_id?id=${productId}&type=single`)
            .then(response => {
                const prd = response.data[0];
                setProduct(prd);
                setTitle(prd.title);

                let iURL = prd?.images?.[0];
                setImgURL(iURL);
                setMovieID(getYoutubeMovieIDfromURL(prd?.YoutubeLink));
            });

    }, []);

    const addToCartHandler = (productId) => {
        dispatch(addToCart(productId));
    };

    const onClickDelete = () => {
        if (window.confirm('글을 삭제하시겠습니까?')) {
            Axios.delete('/api/product/' + Product._id).then(response => {
                if (response.data.success) {
                    alert('삭제되었습니다');
                    history.push('/');
                    deleteStoredImage(props, Product.images);
                }
                else
                    alert(response.data.reason);
            }).catch(err => {
                Axios.post('/api/log/add', { user: props.user.userData._id, log: err }).then(resp => {
                    if (!resp.data.success)
                        throw new Error(resp.err);
                }).catch(err => {
                    throw new Error(err);
                });
            });
        }
    };

    const onClickModify = (evt) => {
        props.history.push({
            pathname: "/product/upload",
            state: { ...Product, isModify: true }
        })
    };

    const onClickReqJoin = () => {
        Axios.put('/api/product/candidates/' + Product._id).then(response => {
            if (response.data.success) {
                setProduct(response.data.prd);
                alert('참여 신청 완료');
            }
            else alert(response.data?.message);
        }).catch(err => {
            console.log(err);
            alert(err.response.data?.message);
        });
    };

    const onClickExit = () => {
        if (window.confirm('프로젝트에서 탈퇴하시겠습니까?')) {
            Axios.delete('/api/product/members/' + Product._id).then(response => {
                if (response.data.success) {
                    setProduct(response.data.prd);
                    alert('탈퇴 완료');
                }
                else alert(response.data?.message);
            }).catch(err => {
                console.log(err);
                alert(err.response.data?.message);
            });
        }
    };

    return (
        <div className='page'>
            <Row gutter={[16, 16]} >
                <Col lg={24} xs={24}>
                    {MovieID ? <YoutubeEmbed embedId={MovieID} /> :
                        ImgURL && <ProductImage detail={Product} />}

                    <ProductCard user={Product?.writer} product={Product} hide_description style={{ marginTop: '5px' }} />
                    <ReactQuill theme="snow" value={Product?.description} modules={{ toolbar: false }} readOnly />
                    <br />

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        {(Product?.writer?._id === props.user?.userData?._id)
                            ? <>
                                <BtnMargined size="large" danger
                                    onClick={onClickDelete}>
                                    삭제
                                </BtnMargined>
                                <BtnMargined size="large" type="primary"
                                    onClick={onClickModify}>
                                    수정
                                </BtnMargined>
                            </>
                            :
                            (Product.members?.[0]?._id && Product.members?.map(c_data => c_data._id)?.includes(props.user?.userData?._id))
                                || (Product.members?.includes(props.user?.userData?._id))
                                ? <BtnMargined size="large" danger
                                    onClick={onClickExit}>
                                    탈퇴하기
                                </BtnMargined>
                                : <BtnMargined size="large" type="primary"
                                    onClick={onClickReqJoin}>
                                    참여 신청
                                </BtnMargined>
                        }
                    </div>

                </Col>
            </Row>
        </div>
    );
}

export default DetailProductPage;
